function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'lime-green': 'rgb(50, 205, 50)','matte-black': 'rgb(40, 40, 43)','matte-army-green': 'rgb(75, 83, 32)','gloss-white': 'rgb(242, 243, 244)','matte-dessert-tan': 'rgb(177, 166, 136)','realtree-excape': 'rgb(166, 146, 115)','kryptek-altitude': 'rgb(166, 146, 115)','army-green': 'rgb(75, 83, 32)','wine-red': 'rgb(114, 47, 55)','tiffany-blue': 'rgb(129, 216, 208)','racing-green': 'rgb(0, 66, 37)','navy-blue': 'rgb(0, 0, 128)','emu-blue': 'rgb(140, 223, 253)','fuschia': 'rgb(227, 195, 201)','onyx-black': 'rgb(53, 57, 53)','heron-white': 'rgb(230, 228, 222)','british-racing-green': 'rgb(0, 66, 37)','graphite-grey': 'rgb(66, 70, 75)','racing-white': 'rgb(255, 255, 255)','carbon-black': 'rgb(41, 53, 66)','mango-green-limited-edition': 'rgb(41, 90, 67)','denim-blue-limited-edition': 'rgb(111, 143, 175)','solarbeam-yellow': 'rgb(255, 176, 39)','gunmetal-grey': 'rgb(66, 70, 75)','baby-blue': 'rgb(137, 207, 240)','dune-burnt-orange': 'rgb(204, 85, 0)','sand-beige': 'rgb(194, 178, 128)','sky-blue': 'rgb(135, 206, 235)','clover-green': 'rgb(50, 77, 18)','peach-pink': 'rgb(255, 154, 138)','babe-pink': 'rgb(244, 194, 194)','blaze-red': 'rgb(107, 0, 0)','military-green': 'rgb(69, 75, 27)','avocado-green': 'rgb(178, 194, 72)','flamingo-pink': 'rgb(252, 142, 172)','snow-white': 'rgb(255, 250, 250)','bumblebee-yellow': 'rgb(255, 219, 148)','gem-blue': 'rgb(15, 82, 186)','galaxy-grey': 'rgb(78, 83, 93)','stone-blue': 'rgb(128, 156, 167)','midnight-blue': 'rgb(25, 25, 112)','mountain-green': 'rgb(71, 147, 87)','space-black': 'rgb(80, 81, 80)','white-orange': 'rgb(254, 239, 214)','black-orange': '','cream': 'rgb(255, 253, 208)','sand': 'rgb(194, 178, 128)','chocolate': 'rgb(123, 63, 0)','blue-special-edition-100': 'rgb(0, 0, 255)','dark-grey': 'rgb(169, 169, 169)','matt-sand': 'rgb(246, 215, 176)','peach': 'rgb(255, 229, 180)','mustard': 'rgb(255, 219, 88)','hemp': 'rgb(214, 218, 203)','chalk': 'rgb(224, 219, 209)','coffee-brown': 'rgb(111, 78, 55)','dust-blue': 'rgb(140, 157, 173)','magma-orange': 'rgb(161, 36, 36)','cloud-blue': 'rgb(209, 223, 246)','nitro-grey': 'rgb(107, 105, 103)','arctic-white': 'rgb(226, 227, 221)','mint': 'rgb(66, 158, 157)','water-green': 'rgb(157, 231, 202)','ginger': 'rgb(176, 101, 0)','bracken-orange': 'rgb(222, 121, 85)','ice-blue': 'rgb(191, 216, 203)','apricot': 'rgb(236, 163, 104)','matte-grey': 'rgb(103, 107, 106)','gloss-black': 'rgb(17, 0, 17)','silver-black': 'rgb(192, 192, 192)','echo-blue': 'rgb(164, 175, 205)','ocean-blue': 'rgb(0, 84, 119)','ultraviolet': 'rgb(123, 109, 141)','dark-night': 'rgb(54, 69, 79)','pastel-blue': 'rgb(211, 227, 236)','iceland-black': 'rgb(48, 48, 48)','amble-latte': 'rgb(177, 130, 99)','royal-blue': 'rgb(65, 105, 225)','iridium-silver': 'rgb(224, 226, 221)','midnight-blue': 'rgb(25, 25, 112)','stone': 'rgb(227, 226, 225)','sangria-red': 'rgb(142, 0, 0)','ink-green': 'rgb(92, 108, 103)','charcoal-grey': 'rgb(85, 85, 96)','mint-green': 'rgb(152, 255, 152)','neon-blue': 'rgb(46, 159, 208)','ice-blue': 'rgb(115, 155, 208)','army-green': 'rgb(69, 75, 27)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','trim colour','rim colour',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
